import App from '@/App.vue';
import { createApp } from 'vue';
import router from './router';
import { Quasar } from 'quasar';

import defineInterceptors from '@/api/httpClient.ts';
import globalAxios from 'axios';

import '/node_modules/flag-icons/css/flag-icons.min.css';

// Design-system semantic tokens (single global import — see tokens.scss header)
import '@/assets/styles/tokens.scss';

import { sharedPinia, sharedI18n, sharedQuasarConfig } from './config/appPlugins';
import '@/assets/styles/global.scss';
import { setupSentry } from '@/config/sentry';
import { setupErrorHandling } from '@/config/errorHandling';
import { setupDecimalConfig } from './config/decimal';

const app = createApp(App);

setupDecimalConfig();
setupErrorHandling();

app.use(sharedI18n);
app.use(sharedPinia);
app.use(router);
app.use(Quasar, sharedQuasarConfig);

setupSentry(app, router);

app.mount('#app');

// Setup HTTP interceptors
defineInterceptors(globalAxios, router);
